import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import * as firebase from 'firebase';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';
import { ProdutosDescontoPersonalizadoDialog } from '../dialogs/produtos-desconto-personalizado-dialog/produtos-desconto-personalizado-dialog';
import { MapaLatlngClienteDialog } from '../dialogs/mapa-latlng-cliente-dialog/mapa-latlng-cliente-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';
import { ExcelService } from '../../services/excel.service';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import telefoneVerdadeiro from '../../funcoes/validar.telefone';
import { ExcluirClienteDialog } from '../dialogs/excluir-cliente-dialog/excluir-cliente-dialog.component';
import { AlertaAlterarCreditoClienteDialog } from '../dialogs/alterar-credito-clientes-dialog/alterar-credito-clientes-dialog';
import { AngularFireDatabase } from '@angular/fire/database';
let pointInPolygon = require('point-in-polygon');

@Component({
  selector: 'app-consultar-cliente',
  templateUrl: './consultar-cliente.component.html',
  styleUrls: ['./consultar-cliente.component.scss', '../../styles/estilo.padrao.scss']
})
export class ConsultarClienteComponent implements OnInit {
  uid;
  bConsultaCarregada: boolean = false;
  bConsulta: boolean = false;
  bPermissaoEditar: boolean = false;
  bBotaoAlterar: boolean = true;
  bErroLatLng: boolean = false;
  // consultaForm: FormGroup;
  clienteForm: FormGroup;
  creditoAnterior: number = 0;
  produtosDescontoSource;
  gruposPromocionais = [];
  displayedColumnsDescontoPersonalizados: string[] = ['Nome', 'Produtos', 'QuantidadeMinima', 'PorcentagemDesconto', 'Remover'];

  vendedores: any[] = [];

  displayedColumns: string[] = ['Nome', 'CPF', 'CNPJ', 'InscricaoEstadual', 'Email', 'StatusString', 'Consultar'];
  idClienteCadastrado;
  clientesSource;
  aClientes = [];
  aRotas = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth,
    private dialog: MatDialog,
    private excelService: ExcelService,
    private db: AngularFireDatabase,
  ) {
    this.uid = localStorage.getItem('uid');

    this.spinner.show('consultar-cliente');

    //Pegar o cliente recém cadastrado
    this.activatedRoute.queryParams.subscribe(value => {
      const dado = value;
      if (dado.IDCliente) {
        this.idClienteCadastrado = dado.IDCliente;
      }
    });

    //Validar Permissões
    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.usuarioService.getFuncionario(this.uid).subscribe(dados => {
          if (dados) {
            const dadosFuncionario: any = dados;
            this.bPermissaoEditar = dadosFuncionario.Permissoes.Alterar.Clientes;
            !this.bPermissaoEditar ? this.bBotaoAlterar = false : true;
          }
        });
      } else
        this.bPermissaoEditar = true;
    });
  }

  //Máscaras
  maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskCEP = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
  maskCNPJ = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/];
  maskCPF = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];

  ngOnInit(): void {
    this.clienteForm = this.formBuilder.group({
      tipoCadastro: ['pessoaFisica', [Validators.required]],
      credito: [1, [Validators.required, Validators.min(1), Validators.max(2000000)]],
      creditoDisponivel: [1, [Validators.required, Validators.min(1), Validators.max(2000000)]],
      nome: ['', [Validators.required]],
      bCompraCheque: [false, [Validators.required]],
      bCompraBoleto: [false, [Validators.required]],
      bCompraNota: [false, [Validators.required]],
      bCompraPagamentoPendente: [false, [Validators.required]],
      cpf: ['', null],
      telefone: ['', [Validators.required, telefoneVerdadeiro]],
      telefoneSecundario: ['', null],
      cep: ['', [Validators.required]],
      logradouro: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      complemento: ['', null],
      bairro: ['', [Validators.required]],
      cidade: ['', [Validators.required]],
      uf: ['', [Validators.required]],
      referencia: ['', null],
      email: ['', [Validators.required, Validators.email]],
      senha: ['', null],
      //Empresa
      cnpj: ['', null],
      razaoSocial: ['', null],
      inscricaoEstadual: ['', null],
      vendedor: ['', null],
      idVendedor: ['', null],
      idCliente: ['', null],
      status: [false, null],
      dataCadastro: ['', null],
      responsavelCompra: ['', null],
      latitude: ['', [Validators.required]],
      longitude: ['', [Validators.required]],
      rota: ['', null],
      prazoNota: ['', [Validators.required, Validators.min(1)]],
    });

    if (this.uid === environment.idCliente) {

      //PEGAR TODAS AS ROTAS PARA EXIBIR NO RELATÓRIO
      this.usuarioService.getTodasRotas().pipe(take(1)).subscribe(snap => {

        if (snap.length > 0) {
          let dados;
          let auxDadosRota;
          let auxArea;
          let auxLatLng;
          snap.forEach((item, index) => {
            dados = item.payload.val();


            Object.keys(dados).forEach((key, index) => {
              auxDadosRota = dados[key];
              auxArea = JSON.parse(auxDadosRota.Area);
              auxLatLng = [];
              for (let i = 0; i < auxArea.length; i++) {
                auxLatLng.push(auxArea[i].lat, auxArea[i].lng)
              }

              this.aRotas.push({
                idCidade: item.key,
                idPoligono: key,
                poligonos: auxLatLng,
                nomeRota: auxDadosRota.Nome,
              });
            });
          });

          this.usuarioService.getClientes().pipe(take(1)).subscribe(snap => {
            this.clientesSource = [];

            if (snap.length > 0) {
              let auxClientes: any[] = [];
              this.aClientes = [];
              var dados;

              snap.forEach((item, index) => {
                dados = item.payload.val();

                if (item.key === this.idClienteCadastrado) {
                  this.consultarCliente({
                    ID: item.key,
                    Status: dados.Status,
                    CompraViaCheque: dados.CompraViaCheque,
                    CompraViaBoleto: dados.CompraViaBoleto,
                    CompraViaNota: dados.CompraViaNota ? dados.CompraViaNota : false,
                    StatusString: dados.Status ? 'Ativo' : 'Desativado',
                    Nome: dados.Nome,
                    CPF: dados.CPF,
                    Telefone: dados.Telefone,
                    TelefoneSecundario: dados.TelefoneSecundario,
                    Email: dados.Email,
                    IDVendedor: dados.IDVendedor,
                    TimestampCadastro: dados.TimestampCadastro,
                    DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
                    CNPJ: dados.CNPJ,
                    Bairro: dados.Bairro,
                    CEP: dados.CEP,
                    Cidade: dados.Cidade,
                    Complemento: dados.Complemento,
                    Credito: dados.Credito,
                    CreditoDisponivel: dados.CreditoDisponivel,
                    InscricaoEstadual: dados.InscricaoEstadual,
                    Logradouro: dados.Logradouro,
                    Numero: dados.Numero,
                    RazaoSocial: dados.RazaoSocial,
                    Referencia: dados.Referencia,
                    Tipo: dados.Tipo,
                    UF: dados.UF,
                    ResponsavelCompra: dados.ResponsavelCompra,
                    GruposPromocionais: dados.GruposPromocionais,
                    Latitude: dados.Latitude,
                    Longitude: dados.Longitude,
                    Rota: this.verificarRota(dados.Latitude, dados.Longitude),
                    CompraPagamentoPendente: dados.CompraPagamentoPendente,
                    PrazoNota: dados.PrazoNota ?? 15
                  });
                } else
                  auxClientes.push({
                    ID: item.key,
                    Status: dados.Status,
                    CompraViaCheque: dados.CompraViaCheque,
                    CompraViaBoleto: dados.CompraViaBoleto,
                    CompraViaNota: dados.CompraViaNota ? dados.CompraViaNota : false,
                    StatusString: dados.Status ? 'Ativo' : 'Desativado',
                    Nome: dados.Nome,
                    CPF: dados.CPF ? dados.CPF : '-',
                    Telefone: dados.Telefone,
                    TelefoneSecundario: dados.TelefoneSecundario,
                    Email: dados.Email,
                    IDVendedor: dados.IDVendedor,
                    TimestampCadastro: dados.TimestampCadastro,
                    DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
                    CNPJ: dados.CNPJ ? dados.CNPJ : '-',
                    Bairro: dados.Bairro,
                    CEP: dados.CEP,
                    Cidade: dados.Cidade,
                    Complemento: dados.Complemento,
                    Credito: dados.Credito,
                    CreditoDisponivel: dados.CreditoDisponivel,
                    InscricaoEstadual: dados.InscricaoEstadual ? dados.InscricaoEstadual : '-',
                    Logradouro: dados.Logradouro,
                    Numero: dados.Numero,
                    RazaoSocial: dados.RazaoSocial,
                    Referencia: dados.Referencia,
                    Tipo: dados.Tipo,
                    UF: dados.UF,
                    ResponsavelCompra: dados.ResponsavelCompra,
                    GruposPromocionais: dados.GruposPromocionais,
                    Latitude: dados.Latitude,
                    Longitude: dados.Longitude,
                    Rota: this.verificarRota(dados.Latitude, dados.Longitude),
                    CompraPagamentoPendente: dados.CompraPagamentoPendente,
                    PrazoNota: dados.PrazoNota ?? 15
                  });
              });

              // this.usuarioService.setLog("Consulta geral de clientes", null, this.uid);
              this.aClientes = auxClientes;
              this.clientesSource = new MatTableDataSource(auxClientes);
              this.clientesSource.paginator = this.paginator;

              setTimeout(() => this.spinner.hide('consultar-cliente'), 300);
            } else {
              this.toastr.error("Não foi possível localizar clientes!", 'Erro');
              setTimeout(() => this.spinner.hide('consultar-cliente'), 300);
            }
          });
        }
      });
    } else {

      //PEGAR TODAS AS ROTAS PARA EXIBIR NO RELATÓRIO
      this.usuarioService.getTodasRotas().pipe(take(1)).subscribe(snap => {

        if (snap.length > 0) {
          let dados;
          let auxDadosRota;
          let auxArea;
          let auxLatLng;
          snap.forEach((item, index) => {
            dados = item.payload.val();


            Object.keys(dados).forEach((key, index) => {
              auxDadosRota = dados[key];
              auxArea = JSON.parse(auxDadosRota.Area);
              auxLatLng = [];
              for (let i = 0; i < auxArea.length; i++) {
                auxLatLng.push(auxArea[i].lat, auxArea[i].lng)
              }

              this.aRotas.push({
                idCidade: item.key,
                idPoligono: key,
                poligonos: auxLatLng,
                nomeRota: auxDadosRota.Nome,
              });
            });
          });

          //Consultar por permissão Vendedor
          this.usuarioService.getClientesVendedor(this.uid).pipe(take(1)).subscribe(snap => {
            this.clientesSource = [];

            if (snap.length > 0) {
              let auxClientes: any[] = [];
              var dados;

              snap.forEach((item, index) => {
                dados = item.payload.val();

                if (item.key === this.idClienteCadastrado) {
                  this.consultarCliente({
                    ID: item.key,
                    Status: dados.Status,
                    CompraViaCheque: dados.CompraViaCheque,
                    CompraViaBoleto: dados.CompraViaBoleto,
                    CompraViaNota: dados.CompraViaNota ? dados.CompraViaNota : false,
                    StatusString: dados.Status ? 'Ativo' : 'Desativado',
                    Nome: dados.Nome,
                    CPF: dados.CPF,
                    Telefone: dados.Telefone,
                    TelefoneSecundario: dados.TelefoneSecundario,
                    Email: dados.Email,
                    IDVendedor: dados.IDVendedor,
                    TimestampCadastro: dados.TimestampCadastro,
                    DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
                    CNPJ: dados.CNPJ,
                    Bairro: dados.Bairro,
                    CEP: dados.CEP,
                    Cidade: dados.Cidade,
                    Complemento: dados.Complemento,
                    Credito: dados.Credito,
                    CreditoDisponivel: dados.CreditoDisponivel,
                    InscricaoEstadual: dados.InscricaoEstadual,
                    Logradouro: dados.Logradouro,
                    Numero: dados.Numero,
                    RazaoSocial: dados.RazaoSocial,
                    Referencia: dados.Referencia,
                    Tipo: dados.Tipo,
                    UF: dados.UF,
                    ResponsavelCompra: dados.ResponsavelCompra,
                    GruposPromocionais: dados.GruposPromocionais,
                    Latitude: dados.Latitude,
                    Longitude: dados.Longitude,
                    Rota: this.verificarRota(dados.Latitude, dados.Longitude),
                    CompraPagamentoPendente: dados.CompraPagamentoPendente,
                    PrazoNota: dados.PrazoNota ?? 15
                  });
                } else
                  auxClientes.push({
                    ID: item.key,
                    Status: dados.Status,
                    CompraViaCheque: dados.CompraViaCheque,
                    CompraViaBoleto: dados.CompraViaBoleto,
                    CompraViaNota: dados.CompraViaNota ? dados.CompraViaNota : false,
                    StatusString: dados.Status ? 'Ativo' : 'Desativado',
                    Nome: dados.Nome,
                    CPF: dados.CPF ? dados.CPF : '-',
                    Telefone: dados.Telefone,
                    TelefoneSecundario: dados.TelefoneSecundario,
                    Email: dados.Email,
                    IDVendedor: dados.IDVendedor,
                    TimestampCadastro: dados.TimestampCadastro,
                    DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
                    CNPJ: dados.CNPJ ? dados.CNPJ : '-',
                    Bairro: dados.Bairro,
                    CEP: dados.CEP,
                    Cidade: dados.Cidade,
                    Complemento: dados.Complemento,
                    Credito: dados.Credito,
                    CreditoDisponivel: dados.CreditoDisponivel,
                    InscricaoEstadual: dados.InscricaoEstadual ? dados.InscricaoEstadual : '-',
                    Logradouro: dados.Logradouro,
                    Numero: dados.Numero,
                    RazaoSocial: dados.RazaoSocial,
                    Referencia: dados.Referencia,
                    Tipo: dados.Tipo,
                    UF: dados.UF,
                    ResponsavelCompra: dados.ResponsavelCompra,
                    GruposPromocionais: dados.GruposPromocionais,
                    Latitude: dados.Latitude,
                    Longitude: dados.Longitude,
                    Rota: this.verificarRota(dados.Latitude, dados.Longitude),
                    CompraPagamentoPendente: dados.CompraPagamentoPendente,
                    PrazoNota: dados.PrazoNota ?? 15
                  });
              });

              this.usuarioService.setLog("Consulta geral de clientes por VENDEDOR", null, this.uid);

              this.clientesSource = new MatTableDataSource(auxClientes);
              this.clientesSource.paginator = this.paginator;

              setTimeout(() => this.spinner.hide('consultar-cliente'), 300);
            } else {
              this.toastr.error("Não foi possível localizar clientes!", 'Erro');
              setTimeout(() => this.spinner.hide('consultar-cliente'), 300);
            }
          });
        }
      });
    }
  }

  verificarRota(latitude, longitude) {
    let rota = 'Não identificada';
    for (let i = 0; i < this.aRotas.length; i++) {
      if (pointInPolygon([latitude, longitude], this.aRotas[i].poligonos)) {
        rota = this.aRotas[i].nomeRota
      }
    }

    return rota;
  }

  consultarCliente(dados) {
    this.bConsultaCarregada = false;
    if (dados) {
      console.log(dados)
      this.spinner.show('consultar-cliente');

      //Recupera os funcionários / Vendedores
      this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
        this.vendedores = [];

        if (snap.length > 0) {
          var auxDados;

          snap.forEach((item, index) => {
            auxDados = item.payload.val();
            if ((auxDados.Status && auxDados.Permissoes.Vender) || (auxDados.IDVendedor === item.key)) {
              this.vendedores.push({
                value: item.key,
                name: auxDados.Nome,
              });
            }
          });

          //Ordena alfabeticamente
          this.vendedores.sort((a, b) => a.value.localeCompare(b.value));

          setTimeout(() => this.spinner.hide('consultar-cliente'), 300);
        }

        this.usuarioService.setLog("Consulta detalhada de cliente. ID " + dados.ID + ' Nome: ' + dados.Nome, null, this.uid);

        this.clienteForm.get('tipoCadastro').patchValue(dados.Tipo);
        this.clienteForm.get('status').patchValue(dados.Status);
        this.clienteForm.get('bCompraCheque').patchValue(dados.CompraViaCheque);
        this.clienteForm.get('bCompraBoleto').patchValue(dados.CompraViaBoleto);
        this.clienteForm.get('bCompraNota').patchValue(dados.CompraViaNota);
        this.clienteForm.get('bCompraPagamentoPendente').patchValue(dados.CompraPagamentoPendente ? dados.CompraPagamentoPendente : false);
        this.clienteForm.get('nome').patchValue(dados.Nome);
        this.clienteForm.get('email').patchValue(dados.Email);
        this.clienteForm.get('telefone').patchValue(dados.Telefone);
        this.clienteForm.get('telefoneSecundario').patchValue(dados.TelefoneSecundario);
        this.onChangeTel(dados.Telefone, true);
        this.onChangeTel(dados.TelefoneSecundario, false);
        dados.CPF !== '-' ? this.clienteForm.get('cpf').patchValue(dados.CPF) : null;
        this.clienteForm.get('dataCadastro').patchValue(dados.DataHoraCadastro);
        this.clienteForm.get('credito').patchValue(dados.Credito);
        this.clienteForm.get('creditoDisponivel').patchValue(dados.CreditoDisponivel);
        this.clienteForm.get('responsavelCompra').patchValue(dados.ResponsavelCompra);

        this.clienteForm.get('credito').setValidators([Validators.required, Validators.min(dados.CreditoDisponivel), Validators.max(2000000)]);

        this.creditoAnterior = dados.Credito;

        this.clienteForm.get('cep').patchValue(dados.CEP);
        this.clienteForm.get('logradouro').patchValue(dados.Logradouro);
        this.clienteForm.get('numero').patchValue(dados.Numero);
        this.clienteForm.get('complemento').patchValue(dados.Complemento);
        this.clienteForm.get('bairro').patchValue(dados.Bairro);
        this.clienteForm.get('cidade').patchValue(dados.Cidade);
        this.clienteForm.get('uf').patchValue(dados.UF);
        this.clienteForm.get('referencia').patchValue(dados.Referencia);
        this.clienteForm.get('email').patchValue(dados.Email);
        dados.CNPJ !== '-' ? this.clienteForm.get('cnpj').patchValue(dados.CNPJ) : null;
        this.clienteForm.get('razaoSocial').patchValue(dados.RazaoSocial);
        dados.InscricaoEstadual !== '-' ? this.clienteForm.get('inscricaoEstadual').patchValue(dados.InscricaoEstadual) : null;
        this.clienteForm.get('vendedor').patchValue('');
        this.clienteForm.get('idVendedor').patchValue(dados.IDVendedor);
        this.clienteForm.get('idCliente').patchValue(dados.ID);

        this.clienteForm.get('latitude').patchValue(dados.Latitude);
        this.clienteForm.get('longitude').patchValue(dados.Longitude);
        this.clienteForm.get('rota').patchValue(dados.Rota);
        this.clienteForm.get('prazoNota').patchValue(dados.PrazoNota ?? 15);

        this.clienteForm.get('tipoCadastro').disable();
        this.clienteForm.get('creditoDisponivel').disable();
        this.clienteForm.get('cpf').disable();
        this.clienteForm.get('cnpj').disable();
        this.clienteForm.get('inscricaoEstadual').disable();
        this.clienteForm.get('email').disable();
        this.clienteForm.get('latitude').disable();
        this.clienteForm.get('longitude').disable();
        this.clienteForm.get('rota').disable();
        this.clienteForm.get('credito').disable();

        !dados.Latitude || !dados.Longitude ? this.bErroLatLng = true : this.bErroLatLng = false;

        this.gruposPromocionais = dados.GruposPromocionais ? dados.GruposPromocionais : [];
        this.produtosDescontoSource = new MatTableDataSource(this.gruposPromocionais);

        //Bloqueia se não puder alterar e não for o admin
        if (this.uid !== environment.idCliente && !this.bPermissaoEditar) {
          this.clienteForm.get('status').disable();
          this.clienteForm.get('nome').disable();
          this.clienteForm.get('razaoSocial').disable();
          this.clienteForm.get('telefone').disable();
          this.clienteForm.get('telefoneSecundario').disable();
          this.clienteForm.get('dataCadastro').disable();
          this.clienteForm.get('responsavelCompra').disable();
          this.clienteForm.get('cep').disable();
          this.clienteForm.get('logradouro').disable();
          this.clienteForm.get('numero').disable();
          this.clienteForm.get('complemento').disable();
          this.clienteForm.get('bairro').disable();
          this.clienteForm.get('cidade').disable();
          this.clienteForm.get('uf').disable();
          this.clienteForm.get('referencia').disable();
          this.clienteForm.get('vendedor').disable();
          this.clienteForm.get('idVendedor').disable();
          this.clienteForm.get('bCompraCheque').disable();
          this.clienteForm.get('bCompraBoleto').disable();
          this.clienteForm.get('bCompraNota').disable();
          this.clienteForm.get('bCompraPagamentoPendente').disable();
          this.clienteForm.get('prazoNota').disable();
        } else {
          // this.clienteForm.get('credito')?.enable();
          if (this.uid !== environment.idCliente) //Pedido do wesley, bloquear essa opção aos vendedores
            this.clienteForm.get('bCompraPagamentoPendente').disable();
          this.bPermissaoEditar = true;
        }

        this.bConsulta = true;
      });

      setTimeout(() => {
        this.bConsultaCarregada = true;
      }, 5000);
    }
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.clientesSource.filter = filterValue.trim().toLowerCase();

    if (this.clientesSource.paginator) {
      this.clientesSource.paginator.firstPage();
    }
  }

  salvar() {

    this.spinner.show('default');

    console.log(this.clienteForm)

    if (this.clienteForm.valid) {
      let map;

      switch (this.f.tipoCadastro.value) {
        case 'pessoaFisica':
          map = {
            Status: this.f.status.value,
            CompraViaCheque: this.f.bCompraCheque.value,
            CompraViaBoleto: this.f.bCompraBoleto.value,
            CompraViaNota: this.f.bCompraNota.value,
            CompraPagamentoPendente: this.f.bCompraPagamentoPendente.value,
            Nome: this.f.nome.value.trim(),
            CPF: this.f.cpf.value.trim(),
            Telefone: this.f.telefone.value.trim(),
            TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
            Email: this.f.email.value.toLowerCase(),
            CEP: this.f.cep.value.trim(),
            Logradouro: this.f.logradouro.value.trim(),
            Numero: this.f.numero.value.trim(),
            Complemento: this.f.complemento.value.trim(),
            Bairro: this.f.bairro.value.trim(),
            Cidade: this.f.cidade.value.trim(),
            UF: this.f.uf.value.trim(),
            Referencia: this.f.referencia.value.trim(),
            Tipo: 'pessoaFisica',
            IDVendedor: this.f.idVendedor.value,
            ResponsavelCompra: this.f.responsavelCompra.value.trim(),
            GruposPromocionais: this.gruposPromocionais,
            Latitude: this.f.latitude.value ? this.f.latitude.value : false,
            Longitude: this.f.latitude.value ? this.f.longitude.value : false,
            PrazoNota: this.f.prazoNota.value,
          }
          this.update(map)
          break;

        case 'pessoaJuridica':
          map = {
            Status: this.f.status.value,
            CompraViaCheque: this.f.bCompraCheque.value,
            CompraViaBoleto: this.f.bCompraBoleto.value,
            CompraViaNota: this.f.bCompraNota.value,
            CompraPagamentoPendente: this.f.bCompraPagamentoPendente.value,
            Nome: this.f.nome.value.trim(),
            Telefone: this.f.telefone.value.trim(),
            TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
            TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP,
            Email: this.f.email.value.toLowerCase(),
            CNPJ: this.f.cnpj.value,
            RazaoSocial: this.f.razaoSocial.value,
            InscricaoEstadual: this.f.inscricaoEstadual.value,
            CEP: this.f.cep.value.trim(),
            Logradouro: this.f.logradouro.value.trim(),
            Numero: this.f.numero.value.trim(),
            Complemento: this.f.complemento.value.trim(),
            Bairro: this.f.bairro.value.trim(),
            Cidade: this.f.cidade.value.trim(),
            UF: this.f.uf.value.trim(),
            Referencia: this.f.referencia.value.trim(),
            Tipo: 'pessoaJuridica',
            IDVendedor: this.f.idVendedor.value,
            ResponsavelCompra: this.f.responsavelCompra.value.trim(),
            GruposPromocionais: this.gruposPromocionais,
            Latitude: this.f.latitude.value ? this.f.latitude.value : false,
            Longitude: this.f.latitude.value ? this.f.longitude.value : false,
            PrazoNota: this.f.prazoNota.value,
          }
          this.update(map)
          break;

        case 'produtorRural':
          if (this.f.inscricaoEstadual.value.toLowerCase() !== 'isento') {
            map = {
              Status: this.f.status.value,
              CompraViaCheque: this.f.bCompraCheque.value,
              CompraViaBoleto: this.f.bCompraBoleto.value,
              CompraViaNota: this.f.bCompraNota.value,
              CompraPagamentoPendente: this.f.bCompraPagamentoPendente.value,
              Nome: this.f.nome.value.trim(),
              CPF: this.f.cpf.value,
              Telefone: this.f.telefone.value.trim(),
              TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
              TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP,
              InscricaoEstadual: this.f.inscricaoEstadual.value,
              Email: this.f.email.value.toLowerCase(),
              CEP: this.f.cep.value.trim(),
              Logradouro: this.f.logradouro.value.trim(),
              Numero: this.f.numero.value.trim(),
              Complemento: this.f.complemento.value.trim(),
              Bairro: this.f.bairro.value.trim(),
              Cidade: this.f.cidade.value.trim(),
              UF: this.f.uf.value.trim(),
              Referencia: this.f.referencia.value.trim(),
              Tipo: 'produtorRural',
              IDVendedor: this.f.idVendedor.value,
              ResponsavelCompra: this.f.responsavelCompra.value.trim(),
              GruposPromocionais: this.gruposPromocionais,
              Latitude: this.f.latitude.value ? this.f.latitude.value : false,
              Longitude: this.f.latitude.value ? this.f.longitude.value : false,
              PrazoNota: this.f.prazoNota.value,
            }
            this.update(map)
          } else {
            this.toastr.error('A Inscrição Estadual não pode ser isenta!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
            this.clienteForm.markAllAsTouched();
            setTimeout(() => this.spinner.hide('default'), 500);
          }
          break;
      }

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.clienteForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  visualizarMapaCliente() {
    const dialogRef = this.dialog.open(MapaLatlngClienteDialog, {
      data: { latitude: this.f.latitude.value, longitude: this.f.longitude.value },
    });
  }

  adicionarProdutoDesconto() {
    if (this.uid === environment.idCliente) {
      const dialogRef = this.dialog.open(ProdutosDescontoPersonalizadoDialog);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {

          // Verificar se não há produtos relacionados com outra promoção.
          const index = this.gruposPromocionais.findIndex(x => x.IDGrupoDesconto === result.IDGrupoDesconto);
          if (index === -1) {

            let auxIDProdutos = [];
            let bPossuiProdutoEmOutraPromocao = false;

            for (let i = 0; i < this.gruposPromocionais.length; i++) {
              for (let j = 0; j < this.gruposPromocionais[i].Produtos.length; j++) {
                auxIDProdutos.push(this.gruposPromocionais[i].Produtos[j].ID)
                for (let k = 0; k < result.Produtos.length; k++) {
                  auxIDProdutos.includes(result.Produtos[k].ID) ? bPossuiProdutoEmOutraPromocao = true : null;
                }
              }
            }

            if (!bPossuiProdutoEmOutraPromocao) {
              this.gruposPromocionais.push({
                IDGrupoDesconto: result.IDGrupoDesconto, Nome: result.Nome, QuantidadeMinima: result.QuantidadeMinima, PorcentagemDesconto: (result.PorcentagemDesconto / 100), Produtos: result.Produtos, ProdutosString: result.ProdutosString
              });
              this.produtosDescontoSource = new MatTableDataSource(this.gruposPromocionais);
            } else
              this.toastr.error("Há um ou mais produtos em conflito com outra promoção para o mesmo cliente", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

          } else
            this.toastr.warning("Este grupo já está adicionado", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        }
      });
    } else {
      this.toastr.error("Você não pode adicionar grupos de desconto à clientes", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  removerDescontoProduto(produto) {
    const index = this.gruposPromocionais.findIndex(x => x.IDGrupoDesconto === produto.IDGrupoDesconto);

    if (index !== -1) {
      const aux = this.gruposPromocionais.filter(item => item.IDGrupoDesconto !== produto.IDGrupoDesconto);
      this.gruposPromocionais = aux;
      this.produtosDescontoSource = new MatTableDataSource(this.gruposPromocionais);
    }
  }

  update(map) {

    if (this.bPermissaoEditar) {
      this.usuarioService.updateCliente(map, this.uid, this.f.idCliente.value).then(resp => {
        if (resp.Status) {
          this.toastr.success(resp.Mensagem, 'Status', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => {
            this.spinner.hide('default');

            this.usuarioService.setLog("Alteração de cliente. ID: " + this.f.idCliente.value + ' Nome: ' + this.f.nome.value, map, this.uid);

            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/consultar-cliente"]));
          }, 1500);
        } else {
          this.toastr.error('Erro: ' + resp.Mensagem, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

          setTimeout(() => {
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro na alteração de cliente. ID: " + this.f.idCliente.value + ' Nome: ' + this.f.nome.value + ' Erro: ' + resp.Mensagem, null, this.uid);

            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/consultar-cliente"]));
          }, 1500);
        }
      });
    } else {
      this.toastr.error('Você não tem permissão para alterar clientes', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  excluirCliente() {
    const dialogRef = this.dialog.open(ExcluirClienteDialog);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show('default');

        this.usuarioService.setLog('Excluindo cliente: ' + this.f.idCliente.value + ' Email: ' + this.f.email.value, null, this.uid).then(resp => {
          this.usuarioService.excluirCliente(this.f.idCliente.value).then(resp => {
            this.toastr.success('Cliente excluído com sucesso.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            setTimeout(() => {
              this.spinner.hide('default');

              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/consultar-cliente"]));
            }, 1500);

          });
        });
      }
    });
  }

  onClickEditarLimiteCliente() {
    const dialogRef = this.dialog.open(AlertaAlterarCreditoClienteDialog, {
      data: { creditoCliente: this.clienteForm.get('credito').value },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show('default');
        let auxCreditoDisponivel = 0;

        try {
          this.db.object('Clientes/' + this.uid + '/Usuarios/' + this.f.idCliente.value + '/CreditoDisponivel').query.ref.transaction(creditoDisponivel => {
            if (creditoDisponivel !== null) {
              creditoDisponivel = creditoDisponivel + result;
              auxCreditoDisponivel = creditoDisponivel.toString();
              return creditoDisponivel;
            }
            return creditoDisponivel;
          }).then(async resp => {
            console.log(resp);
            if (resp.committed) {
              const creditoFinal = Number(this.clienteForm.get('credito').value) + result;
              console.log('creditoFinal', creditoFinal)
              await this.usuarioService.updateCreditoTotalCliente(creditoFinal, this.f.idCliente.value);

              this.clienteForm.get('credito').patchValue(creditoFinal);
              this.clienteForm.get('creditoDisponivel').patchValue(Number(auxCreditoDisponivel));

              this.usuarioService.setLog(`Crédito do cliente alterado em: ${result}`, null, this.uid);
              this.toastr.success(`Crédito atualizado com sucesso!`, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            } else {
              this.usuarioService.setLog(`Falha ao alterar crédito em: ${result} para o cliente: ${this.f.idCliente.value}`, null, this.uid);
              this.toastr.error(`Erro ao alterar crédito do cliente.`, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            }
            this.spinner.hide('default');
          });
        } catch (error) {
          this.spinner.hide('default');
          this.toastr.error(`Erro ao alterar crédito do cliente. ${error}`, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        }
      }
    });
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: true, bCSV: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo)
      }
    });
  }

  imprimir(tipo) {
    var date = new Date();

    switch (tipo) {
      //PDF
      case 0:
        let doc = new jsPDF('l', 'mm', [297, 210]);
        let corpo: any = [];
        this.aClientes.forEach(dado => {
          var aux = [dado.Nome, dado.CPF ? dado.CPF : dado.CNPJ, dado.InscricaoEstadual, dado.Cidade, dado.UF, dado.Status];
          corpo.push(aux);
        });

        autoTable(doc, {
          head: [["Nome", "CPF/CNPJ", "Inscrição Estadual", "Cidade", "UF", "Status"]],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
        });
        doc.save('Relatório_Clientes_' + this.usuarioService.tratarData(date.getTime()) + '.pdf');

        this.usuarioService.setLog("Exportou relatório de usuários em PDF. Período: " + this.usuarioService.tratarData(date.getTime()), null, this.uid);
        break;

      //Excel
      case 1:
        this.excelService.exportAsExcelFile(this.aClientes, 'Relatório_Clientes_' + this.usuarioService.tratarData(date.getTime()));

        this.usuarioService.setLog("Exportou relatório de usuários em EXCEL. Período: " + this.usuarioService.tratarData(date.getTime()), null, this.uid);
        break;

      //CSV
      case 2:
        var options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'Relatório_Clientes_' + this.usuarioService.tratarData(date.getTime()),
          useBom: true,
          noDownload: false,
          headers: ["Status", "CompraViaCheque", "CompraViaBoleto", "Nome", "CPF", "Telefone", "TelefoneSecundario", "Email", "CEP", "Logradouro", "Numero", "Complemento", "Bairro", "Cidade", "UF", "Referencia", "Credito", "CreditoDisponivel", "Tipo", "IDVendedor", "ResponsavelCompra", "GruposPromocionais", "Latitude", "Longitude", "Rota"],
          nullToEmptyString: true,
        };

        new Angular5Csv(this.aClientes, 'Relatório_Clientes_' + this.usuarioService.tratarData(date.getTime()), options);
        this.usuarioService.setLog("Exportou relatório de de usuários em CSV. Período: " + this.usuarioService.tratarData(date.getTime()), null, this.uid);

        break;
    }
  }

  recuperarSenha() {
    this.af.sendPasswordResetEmail(this.f.email.value.toLowerCase()).then(resp => {
      this.toastr.success("Solicitação realizada com sucesso. Por favor verifique o e-mail cadastrado!", 'Status');

      this.usuarioService.setLog("Senha reenviada para o cliente. ID: " + this.f.idCliente.value + ' Nome: ' + this.f.nome.value, null, this.uid);

    }).catch(err => {
      if (err.code === "auth/user-not-found") {
        this.toastr.error("Este e-mail não está cadastrado no sistema!", 'Erro');
      } else {
        this.toastr.error("Houve um erro na solicitação, por favor tente novamente mais tarde!", 'Erro');
      }

      this.usuarioService.setLog("Erro ao reenviar a senha para o cliente. ID: " + this.f.idCliente.value + ' Nome: ' + this.f.nome.value + ' Erro: ' + err, null, this.uid);
    });
  }

  onChangeTel(e, b) {
    if (e.length >= 6) {
      if (e.substring(5, 6) === '9') {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    } else {
      b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  }

  async buscarCEP() {
    if (this.f.cep.value.length == 10 && this.bConsultaCarregada) {
      console.log('buscarCEP');
      console.log(this.f.cep.value.length);

      const resp: any = await this.usuarioService.getBuscaCEP(this.f.cep.value);
      const dados = resp;

      console.log(resp)

      if (dados.erro) {
        this.toastr.warning("Cep inválido!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.clienteForm.get('logradouro').patchValue('');
        this.clienteForm.get('complemento').patchValue('');
        this.clienteForm.get('bairro').patchValue('');
        this.clienteForm.get('cidade').patchValue('');
        this.clienteForm.get('uf').patchValue('');
        this.clienteForm.get('cidade').enable();
        this.clienteForm.get('uf').enable();
      } else {
        this.clienteForm.get('logradouro').patchValue(dados.logradouro);
        this.clienteForm.get('complemento').patchValue(dados.complemento);
        this.clienteForm.get('bairro').patchValue(dados.bairro);
        this.clienteForm.get('cidade').patchValue(dados.localidade);
        this.clienteForm.get('uf').patchValue(dados.uf);
        this.clienteForm.get('cidade').disable();
        this.clienteForm.get('uf').disable();
        this.buscarLatLng();
      }
    }
  }

  async buscarLatLng() {
    if (this.f.logradouro.value.length > 0 && this.f.cidade.value.length > 0) {
      try {
        const aux: any = await this.usuarioService.getLatLng(this.f.logradouro.value + this.f.bairro.value + this.f.cidade.value + '/' + this.f.uf.value);
        console.log(aux);
        const dadosLatLng = aux.results[0].geometry.location;
        this.clienteForm.get('latitude').patchValue(dadosLatLng.lat);
        this.clienteForm.get('longitude').patchValue(dadosLatLng.lng);
      }
      catch (err) {
        console.log(err)
        this.clienteForm.get('latitude').patchValue(false);
        this.clienteForm.get('longitude').patchValue(false);
        this.bErroLatLng = true;
        this.toastr.warning('Não foi possível localizar a latitude e longitude, o gestor deve adicionar manualmente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });

        if (this.uid === environment.idCliente) {
          this.clienteForm.get('latitude').enable();
          this.clienteForm.get('longitude').enable();
        }
      };
    } else {
      this.bErroLatLng = true;
      this.toastr.error("Preencha o endereço antes para verificar a latitude e longitude!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-cliente"]));
  }

  upperCase(event) {
    const ufUpperCase = (event.target as HTMLInputElement).value.toUpperCase();
    this.clienteForm.get('uf').patchValue(ufUpperCase);
  }

  // convenience getter for easy access to form fields
  get f() { return this.clienteForm.controls; }

}
